<template>
  <div class="popupContainer">
    <div class="popupContent" @click="close">
      <img :src="cancel" alt="" class="pointer" @click="close">
      <div class="body">
        <div class="left">
          <img
            alt="logo"
            src="https://s3.ap-northeast-1.amazonaws.com/media.web.pgebet.com/common/logo.svg"
          >
          <h1>
            {{$t('lang.download.betWithPGEbet')}}
          </h1>
          <p>
            {{$t('lang.download.slogan')}}
          </p>
          <p>
            <span>
              {{$t('lang.download.downloadTip1')}}
            </span>
            <a href="https://app.pgebet.com">
              app.PGEbet.com
            </a>
            <span>
              {{$t('lang.download.downloadTip2')}}
            </span>
          </p>
        </div>
        <div class="right">
          <h1 class="android">
            {{$t('lang.download.android')}}
          </h1>
          <img
            alt="download_apk_qr_code"
            src="https://s3.ap-northeast-1.amazonaws.com/media.web.pgebet.com/common/download_apk_qr_code.png"
          >
          <p class="scanToDownload">
            {{$t('lang.download.scan')}}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cancel from '@/assets/images/common/cancel_black.svg'

export default {
  name: 'Popup',
  data () {
    return {
      cancel
    }
  },
  methods: {
    close () {
      this.$store.state.showPopupDownApp = false
    }
  }
}
</script>

<style lang="less" scoped>
  .popupContainer {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,.8);
    z-index: 10;
    .popupContent {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 80%;
      height: 80%;
      transform: translate(-50%,-50%);
      >img {
        position: absolute;
        top: 2px;
        right: 2px;
        width: 28px;
      }
      .body {
        display: flex;
        justify-content: space-evenly;
        align-items: center;

        background: #212324;
        border-radius: 0 0 10px 10px;
        width: 100%;
        height: 100%;

        .left {
          padding: 30px 10px;
          img{
            width: 40%;
          }
          h1 {
            width: 100%;
            text-align: center;
            color: #ffffff;
            line-height: 70px;
            margin: 30px 0;
          }
          p {
            width: 100%;
            text-align: center;
            color: #E4E4E4;
            line-height: 22px;
            margin-bottom: 36px;

            a {
              width: 100%;
              text-align: center;
              color: #F6D9AA;
              text-decoration: none;
            }
          }
        }

        .right {
          position: relative;
          width: 28vw;
          padding: 30px 10px;
          color: #ffffff;

          img {
            margin: 0 auto;
            width: 75%;
          }

          .android {
            text-align: center;
            width: 100%;
            margin-bottom: 22px;
            background: #0A0A0A;
            line-height: 1.5;
            border-radius: 5px;
            white-space: nowrap;
          }

          .scanToDownload {
            text-align: center;
            width: 100%;
            font-size: 24px;
            background: #0A0A0A;
            line-height: 2.2;
            margin-top: 12px;
            border-radius: 5px;
            white-space: nowrap;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Message/DownApp.vue